import { useMolecule } from 'bunshi/react'
import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { StyledButton } from '~/components/elements/StyledButton'
import { useTurnOnAtom } from '~/hooks/jotai'

import { isVisibleDialogMolecule } from '../molecules'

import { EditDiffDialog } from './EditDiffDialog'

export const EditDiffButtonContent = () => {
  const { t } = useTranslation()
  const isVisibleDialogAtom = useMolecule(isVisibleDialogMolecule)
  const isVisibleDialog = useAtomValue(isVisibleDialogAtom)
  const openDialog = useTurnOnAtom(isVisibleDialogAtom)

  return (
    <>
      <StyledButton fillMode="outline" icon="plus" onClick={openDialog}>
        {t('edit_comparison_columns')}
      </StyledButton>

      {isVisibleDialog && <EditDiffDialog />}
    </>
  )
}
